import { useEffect } from 'react';
import { useSiteSettings, resolveSeoTitle } from '../context/SiteSettingsContext';

/**
 * SEO Component for dynamic meta tags per page
 * Updates document title and meta tags for better search engine optimization
 */
export default function SEO({
  title,
  description,
  keywords = '',
  image,
  url = 'https://zemaxi.com',
  type = 'website',
}) {
  const { settings } = useSiteSettings();
  const seo = settings.seo;

  const resolvedTitle = resolveSeoTitle(title, seo.titleTemplate, seo.defaultTitle);
  const resolvedDescription = description || seo.defaultDescription;
  const resolvedKeywords = keywords || seo.defaultKeywords;
  const resolvedImage = image || seo.defaultOgImage;

  useEffect(() => {
    document.title = resolvedTitle;

    const updateMetaTag = (selector, attribute, content) => {
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute(attribute, content);
      } else {
        element = document.createElement('meta');
        const [attr, value] = selector.replace('meta[', '').replace(']', '').split('=');
        element.setAttribute(attr, value.replace(/"/g, ''));
        element.setAttribute(attribute, content);
        document.head.appendChild(element);
      }
    };

    if (resolvedDescription) {
      updateMetaTag('meta[name="description"]', 'content', resolvedDescription);
    }

    if (resolvedKeywords) {
      updateMetaTag('meta[name="keywords"]', 'content', resolvedKeywords);
    }

    updateMetaTag('meta[property="og:title"]', 'content', resolvedTitle);
    updateMetaTag('meta[property="og:description"]', 'content', resolvedDescription);
    updateMetaTag('meta[property="og:image"]', 'content', resolvedImage);
    updateMetaTag('meta[property="og:url"]', 'content', url);
    updateMetaTag('meta[property="og:type"]', 'content', type);

    updateMetaTag('meta[property="twitter:title"]', 'content', resolvedTitle);
    updateMetaTag('meta[property="twitter:description"]', 'content', resolvedDescription);
    updateMetaTag('meta[property="twitter:image"]', 'content', resolvedImage);
    updateMetaTag('meta[property="twitter:url"]', 'content', url);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    }
  }, [resolvedTitle, resolvedDescription, resolvedKeywords, resolvedImage, url, type]);

  return null;
}
